<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h4>Projets associés au client</h4>
    </div>

    <b-alert v-if="projects && projects.length === 0" show variant="info">
      Ce client n'a pas encore de projets associés.
    </b-alert>

    <b-overlay :show="loading" rounded="sm" spinner-variant="primary">
      <b-table
          v-if="projects && projects.length > 0"
          :items="projects"
          :fields="tableFields"
          responsive
          hover
          striped
      >
        <!-- Colonnes personnalisées -->
        <template #cell(status)="data">
          <b-badge :variant="getStatusVariant(data.item.status)">
            {{ getStatusLabel(data.item.status) }}
          </b-badge>
        </template>

        <template #cell(budget)="data">
          {{ formatCurrency(data.item.budget) }}
        </template>

        <template #cell(start_date)="data">
          {{ formatDate(data.item.start_date) }}
        </template>

        <template #cell(end_date)="data">
          {{ formatDate(data.item.end_date) }}
        </template>

        <template #cell(actions)="data">
          <div class="d-flex">
            <b-button
                variant="flat-primary"
                size="sm"
                class="btn-icon mr-1"
                :to="{ name: 'projects-view', params: { id: data.item.uid } }"
            >
              <feather-icon size="16" icon="EyeIcon" />
            </b-button>
            <b-button
                variant="flat-secondary"
                size="sm"
                class="btn-icon"
                :to="{ name: 'projects-edit', params: { id: data.item.uid } }"
            >
              <feather-icon size="16" icon="EditIcon" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-overlay>
  </div>
</template>

<script>
import { formatDate } from '@core/utils/filter'
import {BAlert, BBadge, BButton, BOverlay, BTable} from "bootstrap-vue";

export default {
  name: 'ClientEditTabProjects',
  components: {BBadge, BTable, BOverlay, BAlert, BButton},
  props: {
    client: {
      type: Object,
      required: true
    },
    projects: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tableFields: [
        { key: 'name', label: 'Nom du projet', sortable: true },
        { key: 'status', label: 'Statut', sortable: true },
        { key: 'budget', label: 'Budget', sortable: true },
        { key: 'start_date', label: 'Date de début', sortable: true },
        { key: 'end_date', label: 'Date de fin', sortable: true },
        { key: 'actions', label: 'Actions' }
      ]
    }
  },
  methods: {
    formatDate(value) {
      return value ? formatDate(value, 'DD/MM/YYYY') : 'N/A'
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
      }).format(value || 0)
    },
    getStatusVariant(status) {
      const variants = {
        'active': 'success',
        'pending': 'warning',
        'completed': 'info',
        'cancelled': 'danger'
      }
      return variants[status] || 'secondary'
    },
    getStatusLabel(status) {
      const labels = {
        'active': 'Actif',
        'pending': 'En attente',
        'completed': 'Terminé',
        'cancelled': 'Annulé'
      }
      return labels[status] || status
    }
  }
}
</script>